import {
  AboutUsComponentCareersDiv,
  AboutUsComponentHeroMainDiv,
  AboutUsComponentMainDiv,
  AboutUsComponentTeamCultureDiv,
  AboutUsComponentTeamCultureItemDiv,
  AboutUsComponentTeamCultureItemSection,
  AboutUsComponentTeamDiv,
  AboutUsComponentTimelineDiv,
  AboutUsComponentTimelineItemDiv,
  AboutUsComponentTrustedDiv,
  AboutUsComponentValueDiv,
} from "../../styles/aboutuscomponentstyles/aboutuscomponentstyles";
import Footer from "../reusable/footer/footer";
import ButtonComponentVariant from "../reusable/header/assetes/buttoncomponents/buttoncomponentvarint";
import HeaderSpan from "../reusable/header/assetes/buttoncomponents/headerspan";
import HeaderComponent from "../reusable/header/header";

import Logo from "./assets/bugzi logo 2.png";
import { ReactComponent as Icon } from "./assets/diamond-solid-full.svg";

const AboutusComponent = () => {
  return (
    <AboutUsComponentMainDiv>
      <div className="header-holder">
        <HeaderComponent />
      </div>
      <AboutUsComponentHeroMainDiv>
        <div>
          <div className="aboutus-hero-container">
            <div className="aboutus-hero-header-container">
              <div>
                <HeaderSpan text="about us" />
              </div>
              <div className="aboutus-hero-header-text-container">
                <h1>Empowering Growth Through Scalable AI Solutions</h1>
              </div>
            </div>
            <div>
              <div className="aboutus-hero-image-container">
                <img src={Logo} alt="" />
              </div>
            </div>
            <div className="aboutus-info-container">
              {data.map((item, index) => (
                <div className="aboutus-info-item-container">
                  <div className="aboutus-info-item-wrapper">
                    <div className="aboutus-info-top-wrapper">
                      <div className="aboutus-info-text-wrapper ">
                        <span>200</span>{" "}
                      </div>
                      <div className="aboutus-info-text-wrapper ">
                        <span>+</span>{" "}
                      </div>
                    </div>
                    <div>
                      <div className="aboutus-info-text-wrapper ">
                        <p>AI Implementations</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </AboutUsComponentHeroMainDiv>
      <AboutUsComponentValueDiv>
        <div>
          <div className="aboutus-value-container">
            <div className="aboutus-value-header-container">
              <div>
                <HeaderSpan text="our values " />
              </div>
              <div className="aboutus-value-header-text-container ">
                <div>
                  <h2> Values That Power Our Innovation</h2>
                </div>
              </div>
            </div>
            <div className="aboutus-values-container">
              {data.map((item, index) => (
                <div className="aboutus-value-item-container ">
                  <div className="aboutus-value-item-wrapper">
                    <div>
                      <div className="aboutus-value-image-wrapper">
                        <img src={Logo} alt="" />
                      </div>
                    </div>
                    <div className="aboutus-value-text-container">
                      <div className="aboutus-value-text-wrapper">
                        <h3> Our Mission</h3>
                      </div>
                      <div className="aboutus-value-text-wrapper ">
                        <p>
                          To democratize AI automation, empowering teams to
                          build and deploy intelligent workflows without writing
                          a single line of code.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </AboutUsComponentValueDiv>
      <AboutUsComponentTimelineDiv>
        <div>
          <div className="aboutus-timeline-container">
            <div className="aboutus-timeline-wrapper">
              <div className="aboutus-timeline-line" />
              {data.map((item, index) => (
                <AboutUsComponentTimelineItemDiv reverse={ (index%2) !==0 } >
                  <div>
                    <div className="aboutus-timeline-item-container">
                      <div className="aboutus-timeline-item-circle"></div>
                      <div className="aboutus-timeline-item-wrapper">
                        <div className=" aboutus-timeline-image-container ">
                          <div className="aboutus-timeline-image-wrapper ">
                            <img src={Logo} alt="" />
                          </div>
                        </div>
                        <div className="aboutus-timeline-text-container">
                          <div className="aboutus-timeline-text-wrapper">
                            <h4> 2023</h4>
                          </div>
                          <div className="aboutus-timeline-text-wrapper">
                            <p>
                              Conceived Fusion AI, assembled the founding team,
                              built the core LLM engine, and released an alpha
                              prototype to early testers.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </AboutUsComponentTimelineItemDiv>
              ))}
            </div>
          </div>
        </div>
      </AboutUsComponentTimelineDiv>
      <AboutUsComponentTrustedDiv>
        <div>
          <div className="aboutus-trusted-container ">
            <div className="aboutus-trusted-header-text-container {">
              <div>
                <div>
                  <HeaderSpan text="our backers" />
                </div>
              </div>
              <div>
                <div>
                  <h2>Trusted by Industry-Leading Investors</h2>
                </div>
              </div>
            </div>
            <div className="aboutus-trusted-image-container ">
              {data.map((item, index) => (
                <div
                  key={index + "marquee items"}
                  className="aboutus-trusted-item"
                >
                  <div>
                    <div>
                      <Icon className="aboutus-trusted-icon" />
                    </div>
                  </div>
                  <div className="aboutus-trusted-text">
                    <div>
                      <p>Product </p>
                    </div>
                  </div>
                </div>
              ))}
              {data.map((item, index) => (
                <div
                  key={index + "marquee items"}
                  className="aboutus-trusted-item"
                >
                  <div>
                    <div>
                      <Icon className="aboutus-trusted-icon" />
                    </div>
                  </div>
                  <div className="aboutus-trusted-text">
                    <div>
                      <p>Product </p>
                    </div>
                  </div>
                </div>
              ))}
              {data.map((item, index) => (
                <div
                  key={index + "marquee items"}
                  className="aboutus-trusted-item"
                >
                  <div>
                    <div>
                      <Icon className="aboutus-trusted-icon" />
                    </div>
                  </div>
                  <div className="aboutus-trusted-text">
                    <div>
                      <p>Product </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </AboutUsComponentTrustedDiv>
      <AboutUsComponentTeamDiv>
        <div>
          <div className="aboutus-team-container">
            <div className="aboutus-team-header-text-container">
              <div>
                <HeaderSpan text="our team" />
              </div>
              <div className="aboutus-team-header-text-wrapper ">
                <h2>Meet the Minds Behind Our Innovation</h2>
              </div>
            </div>
            <div className="aboutus-team-body-container">
              {data.map((items) => (
                <div className="aboutus-team-item-container">
                  <div className="aboutus-team-image-wrapper">
                    <img alt="" src={Logo} />
                  </div>
                  <div className="aboutus-team-bottom-container">
                    <div className="aboutus-team-text-container">
                      <div className="aboutus-team-text-wrapper">
                        <h4>Pablo Pardo</h4>{" "}
                      </div>
                      <div className="aboutus-team-text-wrapper">
                        <p> Pablo Pardo</p>
                      </div>
                    </div>
                    <div className="aboutus-team-icon-container">
                      <div className="aboutus-team-icon-wrapper">
                        <Icon />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </AboutUsComponentTeamDiv>
      <AboutUsComponentTeamCultureDiv>
        <div>
          <div className="aboutus-team-culture-container ">
            <div className="aboutus-team-culture-header-text-container">
              <div>
                <HeaderSpan text="Team Culture" />
              </div>
              <div className="aboutus-team-culture-header-text-wrapper">
                <h2>Collaboration, Community, Commitment Define Our Culture</h2>
              </div>
            </div>
            <AboutUsComponentTeamCultureItemSection
              length={data.length}
              itemwidth={652}
              gap={0}
            >
              <section className="aboutus-team-culture-section-container ">
                <div className="aboutus-team-culture-section-holder ">
                  <div className="aboutus-team-culture-marque-container">
                    <div className="aboutus-team-culture-marque-gradient-cover aboutus-team-culture-marque-gradient-cover-right" />
                    <div className="aboutus-team-culture-marque-gradient-cover aboutus-team-culture-marque-gradient-cover-left" />

                    <div className="aboutus-team-culture-marque-scroll-holder">
                      <section>
                        <ul className="aboutus-team-culture-marque-scroll-list">
                          {data.map((item, index) => (
                            <AboutUsComponentTeamCultureItemDiv>
                              <div key={index + "marquee items"}>
                                <div className="aboutus-team-culture-icon">
                                  <img src={Logo} alt="" />
                                </div>
                              </div>
                            </AboutUsComponentTeamCultureItemDiv>
                          ))}
                          {data.map((item, index) => (
                            <AboutUsComponentTeamCultureItemDiv>
                              <div key={index + "marquee items"}>
                                <div className="aboutus-team-culture-icon">
                                  <img src={Logo} alt="" />
                                </div>
                              </div>
                            </AboutUsComponentTeamCultureItemDiv>
                          ))}
                        </ul>
                      </section>
                    </div>
                  </div>
                </div>
              </section>
            </AboutUsComponentTeamCultureItemSection>
          </div>
        </div>
      </AboutUsComponentTeamCultureDiv>
      <AboutUsComponentCareersDiv>
        <div>
          <div className="aboutus-careers-container">
            <div className="aboutus-careers-left-container">
              <div className="aboutus-careers-header-container ">
                <div>
                  <HeaderSpan text="Carrers" />
                </div>
                <div className="aboutus-careers-header-text-wrapper">
                  <h2>Current Job Openings</h2>
                </div>
              </div>
              <div className="aboutus-careers-bottom-text-container">
                <div>
                  <div className="aboutus-careers-header-text-wrapper">
                    <h4>Got any Questions?</h4>
                  </div>
                  <div className="aboutus-careers-header-text-wrapper">
                    <p>
                      Let us know! Reach out and our team will get right back to
                      you.
                    </p>
                  </div>
                </div>
                <div className="aboutus-careers-button-container ">
                  <ButtonComponentVariant title="contact us " />
                </div>
              </div>
            </div>
            <div className="aboutus-careers-right-container">
              {data.map((item, index) => (
                <div className="aboutus-careers-item">
                  <div className="aboutus-careers-item-text-container">
                    <div className="aboutus-careers-item-text-wrapper">
                      <h3>Senior Product Designer</h3>
                    </div>
                    <div className="aboutus-careers-item-details-container">
                      <div className="aboutus-careers-item-details-wrapper">
                        <div className="aboutus-careers-item-icon-wrapper">
                          <Icon />
                        </div>
                        <div className="aboutus-careers-item-text-wrapper">
                          <p> full-time</p>
                        </div>
                      </div>
                      <div className="aboutus-careers-item-details-wrapper">
                        <div className="aboutus-careers-item-icon-wrapper">
                          <Icon />
                        </div>
                        <div className="aboutus-careers-item-text-wrapper">
                          <p> full-time</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <ButtonComponentVariant title="apply" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </AboutUsComponentCareersDiv>

      <div>
        <Footer />
      </div>
    </AboutUsComponentMainDiv>
  );
};

const data = [" ", " ", " "];
export default AboutusComponent;
